module.exports = __webpack_public_path__ + "img/face-recognition-passed.625fc243.png";